import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

enum BLOCKS {
  PARAGRAPH = 'paragraph',
  HYPERLINK = 'hyperlink',
  HEADING_1 = 'heading-1',
}

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node: any, next: any) =>
      `<p class='text-gray-600 font-normal text-md'>${next(node.content)}</p>`,
    [BLOCKS.HEADING_1]: (node: any, next: any) =>
      `<p class='text-gray-900 font-semibold text-lg pb-2'>${next(node.content)}</p>`,
    [BLOCKS.HYPERLINK]: (node: any, next: any) =>
      `<a class='text-sweat-pink-50 visited:text-primary-visited underline inline-flex' 
      href=${node.data.uri} target='_blank'>${next(node.content)}</a>`,
  },
};

export const richTextPartnerPanelFormatter = (content) => {
  const html = documentToHtmlString(content?.json, options);

  return html;
};
